import { TaskmapProduct } from "./taskmap";

export type Terminal = {
  id: string;
  product: TaskmapProduct[];
};

export type TerminalList = Array<Terminal>;

const Terminals: TerminalList = [
  {
    id: "mueller",
    product: [TaskmapProduct.BLOSSOM, TaskmapProduct.VIGOUR],
  },
  {
    id: "fendtone",
    product: [TaskmapProduct.BLOSSOM, TaskmapProduct.VIGOUR],
  },
  {
    id: "BBLeap",
    product: [TaskmapProduct.BLOSSOM],
  },
];

export default function getTerminals(product: TaskmapProduct): TerminalList {
  return Terminals.filter((terminal) => terminal.product.includes(product));
}
